// extracted by mini-css-extract-plugin
export var $animation_name = "ProductPersonalisation-module--$animation_name--e058b";
export var Error = "ProductPersonalisation-module--Error--c5d37";
export var Error___active = "ProductPersonalisation-module--Error___active--0cbdb";
export var ProductPersonalisation = "ProductPersonalisation-module--ProductPersonalisation--bcbb4";